import { render } from "./PartnerDetailModal.vue?vue&type=template&id=b00d2cb4"
import script from "./PartnerDetailModal.vue?vue&type=script&lang=js"
export * from "./PartnerDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__